import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '@americanexpress/dls-react';
import clsx from 'clsx';
import { getDriversAge } from '../../../selectors/filtersSelectors';
import { setDriversAgeAction } from '../../../ducks/filtersDuck';
import { getIsErrorByField } from '../../../selectors/validationSelectors';

const DriversAgeInput = () => {
  const { formatMessage } = useIntl();
  const driversAge = useSelector(getDriversAge);
  const isDriversAgeWarning = useSelector(getIsErrorByField('driversAge'));
  const dispatch = useDispatch();

  const handleChange = ({ target: { value } }) => {
    dispatch(setDriversAgeAction(value));
  };

  return (
    <div className="row">
      <div className="col-xs-6">
        <div className="flex flex-align-center">
          <label className={clsx('color-text-subtle margin-0')} id="driversAgeLabel" htmlFor="driversAge" tabIndex="-1">
            {formatMessage({ id: 'driversAge.placeholder' })}
          </label>
        </div>
        <Input
          id="driversAge"
          value={driversAge}
          type="number"
          className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-control color-text-regular pad-0-lr"
          aria-labelledby="driversAgeLabel"
          status={isDriversAgeWarning && 'error'}
          onChange={handleChange}
          autoComplete="off"
          spellCheck="false"
          data-testid="driversAgeInput"
        />
      </div>
    </div>
  );
};
export default DriversAgeInput;
